// General
exports.sidebarSize = 260;
exports.topbarSize = 60;
exports.scrollbarSize = 17;
exports.defaultPaddingLeft = 40;
exports.mobileDefaultPaddingLeft = 10;
exports.mobileDefaultPaddingRight = 10;
exports.defaultPaddingTop = 40;
exports.mobileDefaultPadding = '25px 10px';
exports.customerSupportTopbarSize = 73;

// UTMODAL
exports.modalPadding = 30;

// UTTABLE
exports.activeRowSize = 338;
exports.inactiveRowSize = 50;

// POINTS
exports.pointsReturnContainerSize = 80;
exports.pointsBannerSize = 280;
exports.pointsHeaderSize = 130;

// VOUCHERS
exports.dotHeight = 7;
exports.dotPadding = 2;

exports.patternHeight = exports.dotHeight + 2 * exports.dotPadding;

exports.voucherWidth = 270;
exports.voucherHeight = 100;

// ACCOUNTS
exports.accountsActiveRowSize = 130;
exports.accountsReturnContainer = 80;
exports.accountSelectorSize = 220;
exports.accountStatusMarginPercent = '90%';

// CHART
exports.dotLineWidth = 6;
exports.activeDotAxisWidth = 11;
exports.chartWidth = 360;
exports.chartHeight = 280;

// UTTABLE Tips
exports.tipActiveRowSize = 170;

// UTTABLE Bills
exports.billsActiveRowSize = 136;

// socialIcon
exports.socialIconSize = 50;
exports.socialButtonIconSize = 32;

// Tips
exports.imageIconTips = 35;

// Signup
exports.progressBarHeight = 80;
